<div class="wrapper d-flex gap-4 flex-nowrap">
	@if (showMenu) {
		<nav>
			<!--    <div class="custom-menu d-lg-none">-->
			<!--      <button  class="btn btn-primary" (click)="showMenu=!showMenu" preIcon="bars">-->
			<!--        <span class="sr-only">Toggle Menu</span>-->
			<!--      </button>-->
			<!--    </div>-->
			<ul class="list-unstyled components">
				@for (sideItem of sideItems; track sideItem) {
					<!-- each click on the side menu changes to url to this section }-->
					<li
						class="sidebar-item"
						[routerLink]="'/config-cliniq/' + sideItem.sectionName"
						(click)="sideMenuClick()"
						[style.background]="
							innerSectionName == sideItem.sectionName &&
							!eventsService.isMobile
								? 'var(--light-grey)'
								: ''
						"
						[preIcon]="sideItem.icon"
					>
						<div class="sidebar-item-text">
							{{ sideItem?.lang || sideItem.sectionName | langVal }}
						</div>
					</li>
				}
			</ul>
		</nav>
	}
	@if (
		configcliniq &&
		(!eventsService.isMobile || (eventsService.isMobile && !showMenu))
	) {
		<div class="sections">
			<div class="d-lg-none">
				<div>
					<button
						class="close"
						tabindex="-1"
						titleLang="back_to_menu"
						(click)="showMenu = !showMenu"
						icon="modal-close"
					></button>
				</div>
				<hr />
			</div>

			@switch (innerSectionName) {
				@case ("headtures") {
					<h4 class="gen-title section-title">{{ "headtures" | langVal }}</h4>
					<app-gen-table2
						tableName="headtures"
						class="headtures"
					/>
				}
				@case ("contacts") {
					<h4 class="gen-title section-title">{{ "contacts" | langVal }}</h4>
					<app-gen-table
						tableName="contacts"
						[filterFieldValue]="null"
					/>
				}
				@case ("products") {
					<h4 class="gen-title section-title">{{ "products" | langVal }}</h4>
					<app-gen-table tableName="products" />
				}
				@case ("policy_forms") {
					<h4 class="gen-title section-title">
						{{ "policy_forms" | langVal }}
					</h4>
					<app-policy-forms-menu />
				}
				@case ("journal") {
					<app-cc-params-journal />
				}
				@case ("user_area") {
					<app-cc-params-user-details />
				}
				@case ("payors") {
					<h4 class="gen-title section-title">{{ "payors" | langVal }}</h4>
					<app-gen-table
						tableName="payors"
						[filterFieldValue]="null"
					/>
				}
				@case ("ownerbankaccounts") {
					<!--<app-gen-table tableName="ownerbankaccounts" />-->
				}
				@case ("patienttypes") {
					<!--<app-gen-table tableName="patienttypes" />-->
				}
				@case ("hashav") {
					<!--<app-cc-params-hashav />-->
				}
				@case ("accountant") {
					<!--<app-cc-params-accountant />-->
				}
				@case ("taxes") {
					<app-cc-params-taxes />
				}
				@case ("zones") {
					<!--<app-cc-params-zones />-->
				}
				@case ("holiday") {
					<app-cc-params-holiday />
				}
				@case ("switches") {
					<app-cc-params-switch />
				}
				@case ("security") {
					<app-cc-params-security />
				}
				@case ("self_coordination") {
					<app-cc-params-self-coordination />
				}
				@case ("automation") {
					<app-cc-params-automation />
				}
				@default {
					<app-cc-sections
						[name]="innerSectionName"
						[section]="innerSectionName"
					/>
				}
			}
		</div>
	}
</div>
